var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2316 6.11358C34.1269 6.63048 34.5787 7.84179 33.9749 8.88757L30.7361 14.5061L30.7417 14.5094L29.5171 16.633L52.0849 29.6625L50.2171 32.8977L27.6511 19.8692L24.6965 24.993C24.0927 26.0388 22.8186 26.2562 21.9214 25.7382C21.5565 25.5275 21.2642 25.2258 21.0668 24.8034L14.8067 10.4479C14.2474 9.19708 15.0697 7.76839 16.4337 7.62549L31.9917 5.84163C32.4582 5.80249 32.8667 5.9029 33.2316 6.11358ZM29.0584 9.93624L19.1546 11.0748L23.1416 20.2106L26.0858 15.1066L29.0584 9.93624Z",
    fill: "var(--textColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8365 30.2622C35.1995 30.4718 35.4899 30.7724 35.6893 31.1959L41.9474 45.5503C42.5105 46.8033 41.6863 48.2309 40.3223 48.3738L24.7643 50.1577C24.2967 50.1987 23.8912 50.0975 23.5263 49.8868C22.631 49.3699 22.1773 48.1575 22.7811 47.1117L26.017 41.494L26.0133 41.4918L26.4841 40.6752L3.91516 27.645L5.78298 24.4099L28.3502 37.439L32.0585 31.0082C32.6633 29.9605 33.9393 29.7442 34.8365 30.2622ZM37.6014 44.9245L33.6155 35.7868L27.6976 46.0631L37.6014 44.9245Z",
    fill: "var(--textColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/Bg1.9c943593d31701192cac94331579160f.svg";
export { ForwardRef as ReactComponent };